<template>
  <div class="col-12">
    <div class="row mt-3">
      <div class="topDraggableMainDiv col-2 pl-0">
        <div class="mx-2 mt-4">
          <!-- <button class="btn btn-secondary" @click="modalType = 1">وضعیت جدید</button> -->
          <b-button block variant="primary" class="w-100" @click="modalType = 0">ستون جدید</b-button>
        </div>
        <draggable :list="allStatuses" tag="div" :group="{ name: 'row' }" v-bind="dragOptions" class="w-100 topDraggable" @change="subDivChange">
          <div v-for="item in allStatuses" :key="item.id" class="p-2 topDraggableMainDivCard">
            <div class="card card-body topDraggableMainDivCardBody mb-0 border-1 rounded-2 d-flex justify-content-start flex-row align-items-center">
              <Status :status="item" />
            </div>
          </div>
        </draggable>
      </div>
      <div class="col-10 pr-0">
        <draggable
          v-model="kanbanColumns"
          tag="div"
          class="mainDraggable d-flex flex-row-reverse"
          @change="mainDivChange"
          v-bind="dragOptions"
          :key="draggableKey"
          handle=".handle"
        >
          <div v-for="(row, idx) in kanbanColumns" :key="row.index" class="sortable my-4 pb-2 flex-column mainCol main-boxShadow">
            <div class="font-size-16 d-flex justify-content-between px-2 py-2" style="cursor: grab">
              <div>
                <i class="fa-solid fa-grid-horizontal fa-rotate-90 fa-xs handle"></i>
                {{ row.name }}
              </div>
              <img
                v-if="kanbanColumns.length > 1"
                class=""
                style="cursor: pointer"
                @click="removeAt(idx)"
                src="@/assets/images/superAdmin/deleteKanbanColumn.png"
                height="20"
                alt=""
              />
            </div>
            <draggable :list="row.statuses" tag="div" :group="{ name: 'row' }" v-bind="dragOptions" class="justify-content-around colDraggable" @change="subDivChange">
              <div v-for="item in row.statuses" :key="item.id" class="d-flex px-2 pt-2">
                <div class="card colDraggableCard rounded-2 d-flex justify-content-start flex-row align-items-center"><Status :status="item" /></div>
              </div>
            </draggable>
          </div>
        </draggable>
      </div>
    </div>
    <Modal size="l" bModalTitle="" :visible="visibleModal">
      <BaseText
        :title="modalTitle"
        class="mb-2"
        @input="colName = $event"
        :value="colName"
        inputType="text"
        placeholder="عنوان"
        :maxlength="30"
        :showError="colError"
        :errortext="colErrorText"
        required
      />
      <Button @click.native="submitModal()" text="ثبت" btnClass="ms-2 aprove btn-border float-end" :loading="btnLoading" />
    </Modal>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Modal from '../../common/modal/customModal.vue'
import BaseText from '../../common/form/formModules/BaseText.vue'
import Button from '../../common/Button.vue'
import { superAdminMixins } from '../../../utils/mixins'
import Status from '../../common/Status.vue'
export default {
  name: 'functional',
  display: 'Functional third party',
  order: 17,
  components: {
    draggable,
    Modal,
    BaseText,
    Button,
    Status,
  },
  mixins: [superAdminMixins],

  data() {
    return {
      draggableKey: 1,
      enabled: true,
      kanbanColumns: [],
      allStatuses: [],
      btnLoading: false,
      colName: '',
      colError: false,
      colErrorText: '',
      visibleModal: false,
      modalType: null,
      modalTitle: '',
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 300,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },
    //   kanbanColumns: {
    //     get() {
    //         return this.$store.state.superAdmin.kanban.columns
    //     },
    //     set(value) {
    //         this.$store.dispatch('superAdmin/setKanbanColumns', value)
    //     }
    // },
    //   allStatuses: {
    //     get() {
    //         return this.$store.state.superAdmin.kanban.availableStatuses
    //     },
    //     set(value) {
    //         this.$store.dispatch('superAdmin/setAvailableStatuses', value)
    //     }
    // }
  },
  methods: {
    mainDivChange(e) {
    },
    subDivChange(e) {
      // this.$store.dispatch('superAdmin/setKanbanColumns', this.kanbanColumns)
    },
    removeAt(idx) {
      if (this.kanbanColumns.length > 1) {
        this.allStatuses.push(...this.kanbanColumns[idx].statuses)
        this.kanbanColumns.splice(idx, 1)
        this.updateStore()
      }
    },
    addColumn(payload) {
      let temp = {
        id: Math.random().toFixed(5),
        name: payload,
        order: 1,
        statuses: [],
      }
      this.kanbanColumns.push(temp)
      this.visibleModal = false
    },
    updateStore() {
      this.setAvailableStatuses(this.allStatuses)
      this.setKanbanColumns(this.kanbanColumns)
    },
    addStatus() {
      this.allStatuses.push({
        code: '1',
        color: 'rgb(52, 195, 143)',
        id: 119,
        value: 'در حال پردازش',
        type: 0,
      })
      this.modalType = null
    },
    submitModal() {
      this.colError = false
      if (this.colName.replace(/\s/g, '').length == 0) {
        this.colError = true
        return
      }
      this.addColumn(this.colName)
      setTimeout(() => {
        this.flushModal()
      }, 300)
    },
    flushModal() {
      this.colName = ''
    },
  },
  watch: {
    modalType(val) {
      if (val == 0) {
        this.modalTitle = 'نام ستون'
        this.colErrorText = 'وارد کردن نام ستون الزامیست!'
        this.visibleModal = true
      } else if (val == 1) {
        this.addStatus()
      }
    },
    visibleModal(val) {
      if (val == false) {
        this.modalType = null
      }
    },
  },

  mounted() {
    this.kanbanColumns = this.columns
    this.allStatuses = this.availableStatuses
  },
  beforeDestroy() {
    this.setAvailableStatuses(this.allStatuses)
    this.setKanbanColumns(this.kanbanColumns)
  },
}
</script>

<style scoped>
@import './style/canban.css';
</style>
